import { ReactNode } from "react"
import useMOG from "src/hooks/useMOG"

function ConnectMOG({ children }: { children: ReactNode }): JSX.Element {
  // useMOG()
  return <>{children}</>
}

export default ConnectMOG
